import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@app/reducers';
import { ConfirmDialogModel, ConfirmDialogPopupComponent, CrudService, CrudType, IApplicationResponse, LoggedInUserModel, ModulesBasedApiSuffix, onActionSubmittedUtil, PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes, RxjsService, SnackbarService, currentComponentPageBasedPermissionsSelector$, getNthDate, prepareDynamicTableTabsFromPermissions, prepareGetRequestHttpParams, prepareRequiredHttpParams, setRequiredValidator } from '@app/shared';
import { TicketSuspendServiceDetailsModel, TicketSuspendServicesDetailsModel } from '@modules/customer';
import { MY_TASK_COMPONENTS } from '@modules/my-tasks/shared/utils/task-list.enum';
import { loggedInUserData } from '@modules/others/auth.selectors';
import { SalesModuleApiSuffixModels } from '@modules/sales';
import { Store } from '@ngrx/store';
import { combineLatest } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { PrimeNgTableVariablesModel } from '../../../../../shared/models/prime-ng-table-list-component-variables.model';
import { DeclineCommentsDialogComponent } from './decline-comments-dialog.component';
@Component({
  selector: 'app-suspension-doa',
  templateUrl: './suspension-doa.component.html',
  styleUrls: ['./suspension-doa.component.scss']
})
export class SuspensionDoaComponent extends PrimeNgTableVariablesModel implements OnInit {
  customerId: any;
  addressId: any;
  contractId: any;
  serviceSuspendId: any;
  suspendServicelationForm: FormGroup;
  contractList: any = [];
  serviceSuspendReasonList: any = [];
  serviceSuspendSubReasonList: any = [];
  reinstateServiceDate: any = new Date();
  billStartDate: any = new Date();
  suspendServiceDate: any = new Date();
  contractLastBillDate: any = new Date();
  submitted: boolean;
  userSubscription: any;
  listSubscription: any;
  isShowNoRecords: any = true;
  primengTableConfigPropertiesObj: any = {
    tableComponentConfigs: {
      tabsList: [{}, {}]
    }
  }
  processName = "";
  BadDebitReinstatement = "BadDebitReinstatement";
  SuspensionDOA = "SuspensionDOA";
  suspensionStatus = "";

  constructor(private crudService: CrudService, private dialog: MatDialog, private route: ActivatedRoute,
    private rxjsService: RxjsService, private snackbarService: SnackbarService,
    private router: Router, private store: Store<AppState>, private formBuilder: FormBuilder, private datePipe: DatePipe) {
    super();
    this.customerId = this.route.snapshot.queryParams['customerId'] ? this.route.snapshot.queryParams['customerId'] : '';
    this.addressId = this.route.snapshot.queryParams['addressId'] ? this.route.snapshot.queryParams['addressId'] : '';
    this.contractId = this.route.snapshot.queryParams['contractId'] ? this.route.snapshot.queryParams['contractId'] : '';
    this.serviceSuspendId = this.route.snapshot.queryParams['id'] ? this.route.snapshot.queryParams['id'] : '';
    this.processName = this.route.snapshot.queryParams['processName'] ? this.route.snapshot.queryParams['processName'] : '';
    this.suspensionStatus = this.route.snapshot.queryParams['suspensionStatus'] ? this.route.snapshot.queryParams['suspensionStatus'] : '';
    this.primengTableConfigProperties = {
      tableCaption: 'Suspension DOA',
      breadCrumbItems: [{ displayName: 'My Task', relativeRouterUrl: '' }, { displayName: 'My Customer', relativeRouterUrl: '/my-tasks/my-customer', queryParams: { tab: 1 } },
      { displayName: 'My DOA', relativeRouterUrl: '' }, { displayName: 'Suspension DOA', relativeRouterUrl: '' }, { displayName: 'Save Offer Approval', relativeRouterUrl: '' }],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            selectedTabIndex: 0,
            dataKey: 'serviceId',
            enableBreadCrumb: true,
            enableAction: true,
            enableScrollable: true,
            checkBox: true,
            rowExpantableIndex: 0,
            cursorLinkIndex: 0,
            cursorSecondLinkIndex: 1,
            columns: [{ field: 'serviceId', header: ' Contract No', width: '120px' },
            { field: 'billId', header: 'Bill ID', width: '150px' },
            { field: 'serviceName', header: 'Service', width: '150px' },
            { field: 'suspendServiceDate', header: 'Termination Date', width: '150px' },
            { field: 'contractStartDate', header: 'Contract Start Date', width: '160px' },
            { field: 'billEndDate', header: 'Bill End Date', width: '150px' },
            { field: 'contractPeriodName', header: 'ICP', width: '150px' },
            { field: 'paymentFrequency', header: 'Freq', width: '150px' },
            { field: 'balanceOfContract', header: 'Balance of Contract', width: '170px' },
            { field: 'contractStatus', header: 'Contract Status', width: '150px', isStatus: true, statusKey: 'statusClass' },],
            apiSuffixModel: SalesModuleApiSuffixModels.SUBSCRIPTION_CANCEL_CONTRACT_DETAIL,
            moduleName: ModulesBasedApiSuffix.SALES,
          }
        ]
      }
    }
    this.primengTableConfigProperties.selectedTabIndex = this.selectedTabIndex;
  }

  ngOnInit(): void {
    this.combineLatestNgrxStoreData();
    this.initForm();
    this.getServiceSuspendReason();
    this.onViewSuspendService();
  }

  initForm(ticketSuspendServiceDetailsModel?: TicketSuspendServiceDetailsModel) {
    let ticketSuspendServiceModel = new TicketSuspendServiceDetailsModel(ticketSuspendServiceDetailsModel);
    this.suspendServicelationForm = this.formBuilder.group({});
    Object.keys(ticketSuspendServiceModel).forEach((key) => {
      if (typeof ticketSuspendServiceModel[key] === 'object') {
        this.suspendServicelationForm.addControl(key, new FormArray(ticketSuspendServiceModel[key]));
      } else {
        this.suspendServicelationForm.addControl(key, new FormControl(ticketSuspendServiceModel[key]));
      }
    });
    this.suspendServicelationForm = setRequiredValidator(this.suspendServicelationForm, ["contractId", "suspendServiceDate",
      "reinstateServiceDate", "billStartDate", "contractLastBillDate", "serviceSuspendReasonId", "serviceSuspendSubReasonId",
      "isEquipmentRemovalRequired", "isSiteVisitRequired", "notes", "services"]);
    this.onFormSetValue();
    this.onValueChanges();
  }

  get getServicesArray(): FormArray {
    if (!this.suspendServicelationForm) return;
    return this.suspendServicelationForm?.get('services') as FormArray;
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  onFormSetValue() {
    this.suspendServicelationForm.patchValue({
      contractId: this.contractId,
      contractLastBillDate: new Date(),
      billStartDate: getNthDate(new Date(), 1),
      createdUserId: this.loggedInUserData?.userId,
      customerId: this.customerId,
      siteAddressId: this.addressId,
    })
    this.suspendServicelationForm.get('contractLastBillDate').disable();
    this.suspendServicelationForm.get('billStartDate').disable();
  }

  onValueChanges() {
    this.suspendServicelationForm.get("serviceSuspendReasonId").valueChanges.pipe(debounceTime(100), distinctUntilChanged()).subscribe(res => {
      if (res) {
        this.crudService.dropdown(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UX_SERVICE_SUSPEND_SUB_REASON, prepareRequiredHttpParams({ serviceSuspendReasonId: res })).subscribe((response: IApplicationResponse) => {
          if (response.isSuccess && response?.statusCode == 200 && response?.resources) {
            this.serviceSuspendSubReasonList = response.resources;
          }
          this.rxjsService.setGlobalLoaderProperty(false);
        });
      }
    });
    this.suspendServicelationForm.get("suspendServiceDate").valueChanges.pipe(debounceTime(100), distinctUntilChanged()).subscribe(res => {
      if (res) {
        this.reinstateServiceDate = getNthDate(res, 1);
      }
    });
  }

  getContracts() {
    this.crudService.dropdown(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UX_SUBSCRIPTION_CANCEL_CONTRACTS, prepareRequiredHttpParams({ customerId: this.customerId, siteAddressId: this.addressId }))
      .subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response?.statusCode == 200 && response?.resources) {
          this.contractList = response?.resources;
          this.setContactRefNo();
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      })
  }

  setContactRefNo() {
    const contractRefNo = this.contractList?.find(el => el?.id == this.contractId);
    this.suspendServicelationForm.get('contractRefNo').setValue(contractRefNo?.displayName);
    this.suspendServicelationForm.get('contractRefNo').disable();
  }

  getServiceSuspendReason() {
    this.crudService.dropdown(ModulesBasedApiSuffix.SALES, SalesModuleApiSuffixModels.UX_SERVICE_SUSPEND_REASON).subscribe((response: IApplicationResponse) => {
      if (response.isSuccess && response?.statusCode == 200 && response?.resources) {
        this.serviceSuspendReasonList = response.resources;
      }
      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }

  combineLatestNgrxStoreData() {
    combineLatest([
      this.store.select(loggedInUserData),
      this.store.select(currentComponentPageBasedPermissionsSelector$)]
    ).subscribe((response) => {
      this.loggedInUserData = new LoggedInUserModel(response[0]);
      // Skip permission validation if processName is BadDebitReinstatement
      if (this.processName === this.BadDebitReinstatement) {
        return;
      }
      let permission = response[1][MY_TASK_COMPONENTS.MY_CUSTOMER]
      if (permission) {
        let prepareDynamicTableTabsFromPermissionsObj = prepareDynamicTableTabsFromPermissions(this.primengTableConfigPropertiesObj, permission);
        this.primengTableConfigPropertiesObj = prepareDynamicTableTabsFromPermissionsObj['primengTableConfigProperties'];
      }
    });
  }

  onActionSubmited(e: any) {
    onActionSubmittedUtil(e, this.onCRUDRequested.bind(this));
  }

  getRequiredListData(pageIndex?: string, pageSize?: string, otherParams?: object) {
    this.loading = true;
    this.isShowNoRecords = false;
    this.dataList = [];
    this.selectedRows = [];
    let salesModuleApiSuffixModels: SalesModuleApiSuffixModels;
    salesModuleApiSuffixModels = this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].apiSuffixModel;
    otherParams = { CustomerId: this.customerId, SiteAddressId: this.addressId, contractId: this.contractId, ...otherParams };
    let api = this.crudService.get(
      this.primengTableConfigProperties.tableComponentConfigs.tabsList[this.selectedTabIndex].moduleName,
      salesModuleApiSuffixModels,
      undefined,
      false, prepareGetRequestHttpParams(pageIndex, pageSize, otherParams));
    if (this.listSubscription && !this.listSubscription.closed) {
      this.listSubscription.unsubscribe();
    }
    this.listSubscription = api.pipe(map((res: IApplicationResponse) => {
      if (res?.resources && res?.statusCode == 200 && this.selectedTabIndex == 0) {
        res?.resources?.forEach(val => {
          val.suspendServiceDate = val.suspendServiceDate ? this.datePipe.transform(val.suspendServiceDate, 'dd-MM-yyyy') : '';
          val.contractStartDate = val.contractStartDate ? this.datePipe.transform(val.contractStartDate, 'dd-MM-yyyy') : '';
          val.billEndDate = val.billEndDate ? this.datePipe.transform(val.billEndDate, 'dd-MM-yyyy') : '';
          val.isSelectedService = val.suspendServiceDate ? true : false;
          val.statusClass = val.contractStatus?.toLowerCase() == 'active' ? 'status-label-green' : val.contractStatus?.toLowerCase() == 'inactive' || val.contractStatus?.toLowerCase() == 'in-active' ? 'status-label-pink' : '';
          val.checkHidden = val.isSelectedService;
          if (this.serviceSuspendId) {
            const filterValue = this.getServicesArray.controls?.find(el => el?.get('serviceId').value == val?.serviceId);
            val.checkedValue = filterValue ? true : false;
          }
          return val;
        });
      }
      return res;
    })).subscribe((data: IApplicationResponse) => {
      this.loading = false;
      this.rxjsService.setGlobalLoaderProperty(false);
      if (data.isSuccess && data?.statusCode == 200) {
        data?.resources?.forEach(el => {
          if (el?.isSelectedService) {
            this.selectedRows.push(el);
          }
        });
        this.dataList = data?.resources;
        this.totalRecords = data?.totalCount;
        this.isShowNoRecords = this.dataList?.length ? false : true;
      } else {
        this.dataList = null
        this.totalRecords = 0;
        this.isShowNoRecords = true;
      }
    })
  }

  onCRUDRequested(type: CrudType | string, row?: object, searchObj?: object): void {
    switch (type) {
      case CrudType.CREATE:
        this.openAddEditPage(CrudType.CREATE, row);
        break;
      case CrudType.GET:
        this.getRequiredListData(row["pageIndex"], row["pageSize"], searchObj)
        break;
      case CrudType.EDIT:
        this.openAddEditPage(CrudType.VIEW, row);
        break;
      default:
    }
  }

  openAddEditPage(type: CrudType | string, editableObject?: object | string): void {
    switch (type) {
      case CrudType.CREATE:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(["../add-edit"], { relativeTo: this.route });
            break;
        }
        break;
      case CrudType.VIEW:
        switch (this.selectedTabIndex) {
          case 0:
            this.router.navigate(['../view'], { relativeTo: this.route, queryParams: { id: editableObject['wdRequestId'] } });
            break;
        }
    }
  }

  initSuspendServiceFormArray(ticketSuspendServicesDetailsModel?: TicketSuspendServicesDetailsModel) {
    let ticketSuspendServicesModel = new TicketSuspendServicesDetailsModel(ticketSuspendServicesDetailsModel);
    let ticketSuspendServicesFormArray = this.formBuilder.group({});
    Object.keys(ticketSuspendServicesModel).forEach((key) => {
      ticketSuspendServicesFormArray.addControl(key, new FormControl({ value: ticketSuspendServicesModel[key], disabled: true }));
    });
    this.getServicesArray.push(ticketSuspendServicesFormArray);
  }

  onChangeSelecedRows(e) {
    this.selectedRows = e;
    this.clearFormArray(this.getServicesArray);
    if (this.selectedRows?.length) {
      this.selectedRows.forEach((el: any) => {
        if (!el?.suspendServiceDate) {
          this.initSuspendServiceFormArray({
            serviceSuspendDetailId: '',
            serviceId: el?.serviceId,
          })
        }
      });
    }
  }

  openApprove() {
    // Skip permission validation if processName is BadDebitReinstatement
    if (this.processName !== this.BadDebitReinstatement &&
      this.primengTableConfigPropertiesObj?.tableComponentConfigs?.tabsList?.[1] &&
      !this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[1].canApprove) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
    }
    if (this.suspendServicelationForm.invalid) {
      this.suspendServicelationForm.markAllAsTouched();
      return;
    }
    const message = this.processName == this.BadDebitReinstatement ? `Are you sure you want to Approve this?` : `Are you sure you want to Approve this Suspension?`;
    const dialogData = new ConfirmDialogModel("Suspension Request", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (!dialogResult) return;
      let reqObj;
      if (this.processName == this.BadDebitReinstatement) {
        const formData = new FormData();
        const approvalObj = {
          roleId: this.loggedInUserData?.roleId,
          approvedUserId: this.loggedInUserData?.userId,
          comments: null,
          referenceNo: this.serviceSuspendId,
          approvalStatus: "approved"
        };
        formData.append('approvalRequest', JSON.stringify(approvalObj));
        reqObj = formData;
      } else {
        reqObj = {
          serviceSuspendId: this.serviceSuspendId,
          modifiedUserId: this.loggedInUserData?.userId,
        };
      }
      this.submitted = true;
      const api = this.processName == this.BadDebitReinstatement ? SalesModuleApiSuffixModels.POTENTIAL_SUBSCRIPTION_SUSPEND_DOA_APPROVAL : SalesModuleApiSuffixModels.SERVICE_SUSPEND_DOA_APPROVAL;
      const crudService = this.processName == this.BadDebitReinstatement ? this.crudService.create(ModulesBasedApiSuffix.SALES, api, reqObj) : this.crudService.update(ModulesBasedApiSuffix.SALES, api, reqObj);
      crudService
        .subscribe((res: IApplicationResponse) => {
          if (res?.isSuccess && res?.statusCode == 200) {
            this.onBack();
          }
          this.submitted = false;
          this.rxjsService.setGlobalLoaderProperty(false);
        })
    });
  }

  openDecline() {
    // Skip permission validation if processName is BadDebitReinstatement
    if (this.processName !== this.BadDebitReinstatement &&
      this.primengTableConfigPropertiesObj?.tableComponentConfigs?.tabsList?.[1] &&
      !this.primengTableConfigPropertiesObj.tableComponentConfigs.tabsList[1].canDecline) {
      return this.snackbarService.openSnackbar(PERMISSION_RESTRICTION_ERROR, ResponseMessageTypes.WARNING);
    }
    if (this.suspendServicelationForm.invalid) {
      this.suspendServicelationForm.markAllAsTouched();
      return;
    }
    const message = this.processName == this.BadDebitReinstatement ? `Are you sure you want to Decline this?` : `Are you sure you want to Decline this Suspension?`;
    const dialogData = new ConfirmDialogModel("Suspension Request", message);
    const dialogRef = this.dialog.open(ConfirmDialogPopupComponent, {
      maxWidth: "400px",
      data: dialogData,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(dialogResult => {
      if (!dialogResult) return;

      // Show comments dialog for BadDebitReinstatement decline
      if (this.processName == this.BadDebitReinstatement || this.processName == this.SuspensionDOA) {
        const commentsDialogRef = this.dialog.open(DeclineCommentsDialogComponent, {
          maxWidth: "500px",
          width: "500px",
          disableClose: true
        });

        commentsDialogRef.afterClosed().subscribe(comments => {
          if (!comments) return; // User cancelled comments dialog

          const formData = new FormData();
          const approvalObj = {
            roleId: this.loggedInUserData?.roleId,
            approvedUserId: this.loggedInUserData?.userId,
            comments,
            referenceNo: this.serviceSuspendId,
            approvalStatus: "declined"
          };
          formData.append('approvalRequest', JSON.stringify(approvalObj));

          this.submitted = true;
          const api = this.processName == this.BadDebitReinstatement ? SalesModuleApiSuffixModels.POTENTIAL_SUBSCRIPTION_SUSPEND_DOA_APPROVAL : SalesModuleApiSuffixModels.SERVICE_SUSPEND_DOA_DECLINE;
          const crudService = this.processName == this.BadDebitReinstatement ? this.crudService.create(ModulesBasedApiSuffix.SALES, api, formData) : this.crudService.update(ModulesBasedApiSuffix.SALES, api, {
            serviceSuspendId: this.serviceSuspendId,modifiedUserId: this.loggedInUserData?.userId,comments
          });
          crudService
            .subscribe((res: IApplicationResponse) => {
              if (res?.isSuccess && res?.statusCode == 200) {
                this.onBack();
              }
              this.submitted = false;
              this.rxjsService.setGlobalLoaderProperty(false);
            });
        });
      } else {
        // Non-BadDebitReinstatement flow
        const reqObj = {
          serviceSuspendId: this.serviceSuspendId,
          modifiedUserId: this.loggedInUserData?.userId,
        };
        this.submitted = true;
        const api = SalesModuleApiSuffixModels.SERVICE_SUSPEND_DOA_DECLINE;
        this.crudService.update(ModulesBasedApiSuffix.SALES, api, reqObj)
          .subscribe((res: IApplicationResponse) => {
            if (res?.isSuccess && res?.statusCode == 200) {
              this.onBack();
            }
            this.submitted = false;
            this.rxjsService.setGlobalLoaderProperty(false);
          });
      }
    })
  }

  getRetractSubs() {
    return this.suspendServicelationForm.get('status')?.value?.toLowerCase() == 'future supension' || (this.suspendServicelationForm.get('status')?.value?.toLowerCase() == 'doa pending') || this.suspendServicelationForm.get('status')?.value?.toLowerCase() == 'doa approved-fs';
  }

  getDOASubs() {
    return this.suspendServicelationForm.get('status')?.value?.toLowerCase() == 'doa pending';
  }

  onViewSuspendService() {
    const api = this.processName == this.BadDebitReinstatement ? SalesModuleApiSuffixModels.POTENTIAL_SUBSCRIPTION_SUSPEND_DETAIL_REINSTATEMENT : SalesModuleApiSuffixModels.SUBSCRIPTION_SUSPEND_DETAIL;
    this.crudService.get(ModulesBasedApiSuffix.SALES, api, null, false,
      this.processName == this.BadDebitReinstatement ? prepareRequiredHttpParams({ badDebitSuspensionReInStateId: this.serviceSuspendId }) : prepareRequiredHttpParams({ serviceSuspendId: this.serviceSuspendId }))
      .pipe(map((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200 && res?.resources?.contracts) {
          res?.resources?.contracts?.forEach(val => {
            val.suspendServiceDate = val.suspendServiceDate ? this.datePipe.transform(val.suspendServiceDate, 'dd-MM-yyyy') : '';
            val.contractStartDate = val.contractStartDate ? this.datePipe.transform(val.contractStartDate, 'dd-MM-yyyy') : '';
            val.billEndDate = val.billEndDate ? this.datePipe.transform(val.billEndDate, 'dd-MM-yyyy') : '';
            val.statusClass = val.contractStatus?.toLowerCase() == 'active' ? 'status-label-green' : val.contractStatus?.toLowerCase() == 'inactive' || val.contractStatus?.toLowerCase() == 'in-active' ? 'status-label-pink' : '';
            return val;
          });
          this.customerId = res?.resources?.customerId;
          this.addressId = res?.resources?.siteAddressId;
          this.getContracts();
        }
        return res;
      })).subscribe((res: IApplicationResponse) => {
        if (res?.isSuccess && res?.statusCode == 200) {
          this.suspendServicelationForm.reset();
          this.suspendServicelationForm.patchValue({
            reinstateServiceDate: res?.resources?.reinstateServiceDate ? new Date(res?.resources?.reinstateServiceDate) : '',
            suspendServiceDate: res?.resources?.suspendServiceDate ? new Date(res?.resources?.suspendServiceDate) : '',
            contractLastBillDate: res?.resources?.contractLastBillDate ? new Date(res?.resources?.contractLastBillDate) : '',
            billStartDate: res?.resources?.billStartDate ? new Date(res?.resources?.billStartDate) : '',
            serviceSuspendReasonId: res?.resources?.serviceSuspendReasonId,
            serviceSuspendSubReasonId: res?.resources?.serviceSuspendSubReasonId,
            isEquipmentRemovalRequired: res?.resources?.isEquipmentRemovalRequired,
            isSiteVisitRequired: res?.resources?.isSiteVisitRequired,
            status: res?.resources?.status ? res?.resources?.status : '',
            notes: res?.resources?.notes,
            customerId: res?.resources?.customerId,
            siteAddressId: res?.resources?.siteAddressId,
            createdUserId: res?.resources?.createdUserId,
            leadId: res?.resources?.leadId,
            leadRefNo: res?.resources?.leadRefNo,
            ticketId: res?.resources?.ticketId,
            ticketRefNo: res?.resources?.ticketRefNo,
            actionTypeID: res?.resources?.actionTypeID,
            contractId: res?.resources?.contractId,
          }, { emitEvent: false });
          res?.resources?.services?.forEach(el => {
            this.initSuspendServiceFormArray({
              serviceSuspendDetailId: el?.serviceSuspendDetailId,
              serviceId: el?.serviceId,
            });
          });
          this.setContactRefNo();
          this.dataList = res?.resources?.contracts;
          this.totalRecords = 0;
          this.isShowNoRecords = this.dataList?.length ? false : true;
          this.suspendServicelationForm.get('serviceSuspendReasonId').patchValue(res?.resources?.serviceSuspendReasonId);
          this.suspendServicelationForm.get('isEquipmentRemovalRequired').patchValue(res?.resources?.isEquipmentRemovalRequired);
          this.suspendServicelationForm.get('isSiteVisitRequired').patchValue(res?.resources?.isSiteVisitRequired);
          this.primengTableConfigProperties.tableComponentConfigs.tabsList[0].checkBox = false;
          this.suspendServicelationForm.disable({ emitEvent: false });
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      })
  }

  onBack() {
    if (this.processName == this.BadDebitReinstatement) {
      this.router.navigateByUrl('collection/my-task-list');
    } else {
      this.router.navigate(['./my-tasks/my-customer'], { queryParams: { tab: 1 } });
    }
  }
}
